import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';
import { LottiePlayerConfig } from 'src/app/shared/components/lottie-player/lottie-player.component';
import { JobsService } from './../../services/jobs/jobs.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'jobs-view',
  templateUrl: './jobs-view.component.html',
  styleUrls: ['./jobs-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobsViewComponent implements OnInit, OnDestroy {
  public animation = 'loading';
  public animationConfig: LottiePlayerConfig;
  public hasJobs = false;

  private _sub: Subscription;

  constructor(
    public service: JobsService,
    public element: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    this.animationConfig = {
      path: 'assets/lottie/customs/loader.json',
      type: 'loop',
      segments: {
        loading: [0, 120],
        success: [240, 400],
        error: [660, 825]
      }
    };
  }

  ngOnInit() {
    this.hasJobs = this.service.hasJobs;
    this._sub = this.service.jobs$.subscribe(() => {
      Promise.resolve().then(() => {
        this.hasJobs = this.service.hasJobs;
        this.cdr.markForCheck();
      });
    });
  }

  ngOnDestroy() {
    this._sub?.unsubscribe();
  }

  @HostBinding('style.display') get display() {
    return this.hasJobs ? 'flex' : 'none';
  }
  
}
